import { Col, Empty, Row } from "antd";
import PageLoader from "../../components/PageLoader";
import moment from "moment";
import React, { useEffect, useState } from "react";
import HealthScreenList from "../../components/views/ScreenHealthAnalytics/HealthScreenList";
import { THEME_PALLETE } from "../../Theme";
import HealthScreenDetail from "../../components/views/ScreenHealthAnalytics/HealthScreenDetail";
import { Monitor, Wifi, WifiOff, TrendingUp } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const OnlineStatusAnalytics = (props) => {
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).analytics;
  const [loading, setLoading] = useState(false);
  const [selectedScreen, setSelectedScreen] = useState(null);
  const [selectedScreenData, setSelectedScreenData] = useState(null);
  const [screensStatusList, setScreensStatusList] = useState([
    // {
    //     "ScreenName": "BBQ 965 206 570",
    //     "ScreenID": 123,
    //     "BranchName": "Bangkok HQ",
    //     "data": [
    //         {
    //             "LogDate": "2025-05-09",
    //             "ActivePercentage": "0.00",
    //             "InactivePercentage": "0.00",
    //             "NotDataPercentage": "100.00"
    //         }
    //     ]
    // }
  ]);

  useEffect(() => {
    console.log("OnlineStatusAnalytics useEffect");
    if (!selectedScreen) return;
    console.log(
      "OnlineStatusAnalytics useEffect getScreenData " +
        JSON.stringify(selectedScreen),
    );
    getScreenData(selectedScreen.ScreenID);
  }, [selectedScreen]);

  useEffect(() => {
    console.log("OnlineStatusAnalytics useEffect");
    if (!props.parentProps) return;
    const { selectedBrandData } = props.parentProps;

    if (!selectedBrandData) return;

    console.log(
      "OnlineStatusAnalytics useEffect " + JSON.stringify(selectedBrandData),
    );
    getScreensStatusList();
  }, [props.parentProps]);

  useEffect(() => {
    if (setSelectedScreen && setSelectedScreen.length > 0) {
      setSelectedScreen(screensStatusList[0]);
      console.log("screensStatusList " + JSON.stringify(screensStatusList));
    }
  }, [screensStatusList]);

  const getScreenData = (screenid) => {
    if (!props.parentProps) return;
    const { usertoken, requestServerGet, selectedBrandData } =
      props.parentProps;

    setLoading(true);

    try {
      requestServerGet(
        "get_analyticsonlinebyscreen",
        { screenid },
        null,
        (response) => {
          console.log("screens status Log " + JSON.stringify(response.data));
          // const options = response.data.map(data => {
          //     return { value: data.CampaignID, label: data.CampaignName }
          // })

          setLoading(false);
          setSelectedScreenData(response.data.data);

          // this.setState({ campaigntDatas: options, campaignOptions: options })
        },
        usertoken,
      );
    } catch (e) {
      console.log("Error " + e);
      setLoading(false);
    }
  };
  const getScreenAVGUpPercentage = (screen) => {
    if (!screen || !screen.data || screen.data.length === 0) return 0;
    const sumUpTime = screen.data.reduce(
      (acc, data) => acc + data.ActivePercentage,
      0,
    );
    const avgUpTime = sumUpTime / screen.data.length;
    return Math.round(avgUpTime * 100) / 100;
  };

  const getScreensStatusList = (params) => {
    console.log("getScreensStatusList");
    if (!props.parentProps) return;
    const { usertoken, requestServerGet, selectedBrandData } =
      props.parentProps;

    if (!selectedBrandData) return;

    setLoading(true);

    var endDate = moment().subtract(0, "days").format("YYYY-MM-DD");
    var startDate = moment().subtract(6, "days").format("YYYY-MM-DD");

    try {
      requestServerGet(
        "get_analyticsonline",
        {
          brandid: selectedBrandData.BrandID,
          startdate: startDate,
          enddate: endDate,
          ...params,
        },
        null,
        (response) => {
          console.log("screens status Log " + JSON.stringify(response.data));
          // const options = response.data.map(data => {
          //     return { value: data.CampaignID, label: data.CampaignName }
          // })

          setLoading(false);
          setScreensStatusList(
            response.data.data.sort((a, b) => {
              const aPercent = getScreenAVGUpPercentage(a);
              const bPercent = getScreenAVGUpPercentage(b);
              return bPercent - aPercent;
            }),
          );

          // .sort((a,b)=>{
          //             const aPercent = getScreenAVGUpPercentage(a);
          //             const bPercent = getScreenAVGUpPercentage(b);
          //             return  aPercent- bPercent;
          //         })
          // this.setState({ campaigntDatas: options, campaignOptions: options })
        },
        usertoken,
      );
    } catch (e) {
      console.log("Error " + e);
      setLoading(false);
    }
  };

  const onScreenSelected = (selectedID) => {
    console.log("onScreenSelected " + selectedID);

    const newSelectedScreen = screensStatusList.find(
      (screen) => screen.ScreenID === selectedID,
    );
    if (!newSelectedScreen) {
      console.log("Screen not found " + selectedID);
      return;
    }
    console.log("selectedScreen " + JSON.stringify(newSelectedScreen));
    setSelectedScreen(newSelectedScreen);
  };
  const totalScreens = screensStatusList.length;
  const onlineScreens = screensStatusList.filter(
    (s) => s.DataFirebase && s.DataFirebase.is_online,
  ).length;
  const avgUptime =
    totalScreens > 0
      ? Math.round(
          (screensStatusList.reduce(
            (acc, s) => acc + getScreenAVGUpPercentage(s),
            0,
          ) /
            totalScreens) *
            10,
        ) / 10
      : 0;

  const statCards = [
    {
      label: t.statTotalScreens,
      value: totalScreens,
      icon: Monitor,
      color1: "#6366f1",
      color2: "#4f46e5",
    },
    {
      label: t.statOnlineNow,
      value: onlineScreens,
      icon: Wifi,
      color1: "#10b981",
      color2: "#059669",
    },
    {
      label: t.statOffline,
      value: totalScreens - onlineScreens,
      icon: WifiOff,
      color1: "#f43f5e",
      color2: "#e11d48",
    },
    {
      label: t.statAvgUptime,
      value: `${avgUptime}%`,
      icon: TrendingUp,
      color1: "#0ea5e9",
      color2: "#0284c7",
    },
  ];

  return (
    <div
      className="online-status-analytics"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 16,
        paddingBottom: 16,
        position: "relative",
      }}
    >
      {/* Summary stat cards */}
      <Row gutter={[12, 12]}>
        {statCards.map((card, i) => (
          <Col key={i} xs={12} lg={6}>
            <div
              style={{
                background: "#fff",
                borderRadius: 14,
                border: "1px solid #f1f5f9",
                padding: "14px 18px",
                display: "flex",
                alignItems: "center",
                gap: 14,
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
              }}
            >
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 11,
                  background: `linear-gradient(135deg,${card.color1},${card.color2})`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <card.icon size={18} color="#fff" />
              </div>
              <div>
                <div
                  style={{
                    fontSize: 20,
                    fontWeight: 700,
                    color: "#0f172a",
                    lineHeight: 1.2,
                  }}
                >
                  {card.value}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#94a3b8",
                    marginTop: 2,
                    fontWeight: 500,
                  }}
                >
                  {card.label}
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      {/* Main panels */}
      {loading && <PageLoader text={t.loading} />}
      {!loading && screensStatusList.length > 0 ? (
        <Row gutter={[16, 16]} style={{ flex: 1, minHeight: 0 }}>
          <Col
            xs={24}
            lg={10}
            style={{
              display: "flex",
              flexGrow: 1,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <HealthScreenList
              parentProps={props.parentProps}
              screens={screensStatusList}
              loading={loading}
              selectedScreen={selectedScreen}
              onSelectScreen={onScreenSelected}
            />
          </Col>
          <Col
            xs={24}
            lg={14}
            style={{
              display: "flex",
              width: "100%",
              flexGrow: 1,
              flexDirection: "column",
            }}
          >
            <HealthScreenDetail
              loading={loading}
              screen={selectedScreen}
              data={selectedScreenData}
            />
          </Col>
        </Row>
      ) : !loading ? (
        <div
          style={{
            background: "#fff",
            borderRadius: 14,
            border: "1px solid #f1f5f9",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            padding: "60px 20px",
            textAlign: "center",
          }}
        >
          <Empty
            description={
              <span style={{ color: "#94a3b8" }}>
                {t.emptyNoScreens || "No screen data available"}
              </span>
            }
          />
        </div>
      ) : null}
    </div>
  );
};

export default OnlineStatusAnalytics;
